import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M5 24.375V21.25a.625.625 0 0 1 1.25 0v2.5h2.5a.625.625 0 0 1 0 1.25H5.625A.625.625 0 0 1 5 24.375ZM24.375 25H21.25a.625.625 0 0 1 0-1.25h2.5v-2.5a.625.625 0 0 1 1.25 0v3.125c0 .345-.28.625-.625.625ZM25 5.625V8.75a.625.625 0 0 1-1.25 0v-2.5h-2.5a.625.625 0 0 1 0-1.25h3.125c.345 0 .625.28.625.625ZM5.625 5H8.75a.625.625 0 0 1 0 1.25h-2.5v2.5a.625.625 0 0 1-1.25 0V5.625C5 5.28 5.28 5 5.625 5Zm3.75 3.75h11.25c.345 0 .625.28.625.625v11.25c0 .345-.28.625-.625.625H9.375a.625.625 0 0 1-.625-.625V9.375c0-.345.28-.625.625-.625ZM10 10v10h10V10H10Zm1.25 1.25h7.5v7.5h-7.5v-7.5Z" fill="currentColor" />' }
  })
);